import { render, staticRenderFns } from "./ModalBuilding.vue?vue&type=template&id=7ba35d3c"
import script from "./ModalBuilding.vue?vue&type=script&lang=js"
export * from "./ModalBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports